import { render, staticRenderFns } from "./NurseAndMidwifeInfo.vue?vue&type=template&id=51901894"
import script from "./NurseAndMidwifeInfo.vue?vue&type=script&lang=js"
export * from "./NurseAndMidwifeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports